import type { FC } from 'react'
import { useTheoryCopy } from '../theory-copy/use-theory-copy.js'
import type { DirectionParam } from './ear-training-params.js'
import styles from './ear-training-direction-picker.module.css'

export interface EarTrainingDirectionPickerProps {
  value: DirectionParam
  onChange: (value: DirectionParam) => void
}

const OPTIONS: { value: DirectionParam; label: string }[] = [
  { value: 'ascending', label: 'Ascending' },
  { value: 'descending', label: 'Descending' },
  { value: 'harmonic', label: 'Harmonic' },
  { value: 'mixed', label: 'Mixed' },
]

/**
 * Direction picker for Interval ID sub-mode. Four-option radio group rendered
 * as a segmented control. Lexicon-driven label copy adapts to theory level.
 *
 * Spec: docs/superpowers/specs/2026-05-21-ear-training-v15-design.md §5.2
 */
export const EarTrainingDirectionPicker: FC<EarTrainingDirectionPickerProps> = props => {
  const { value, onChange } = props
  const copy = useTheoryCopy('ear-training-direction-picker')
  return (
    <div className={styles.picker} role="radiogroup" aria-label="Interval direction">
      {copy?.body ? <p className={styles.label}>{copy.body}</p> : null}
      <div className={styles.options}>
        {OPTIONS.map(option => (
          <label key={option.value} className={styles.option}>
            <input
              type="radio"
              name="ear-training-direction"
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
            />
            <span className={styles.optionText}>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  )
}
